import {
  IAssetsByRelationshipsResponseDataGraphQL,
  IAssetsContentResponseDataGraphQL,
  IAssetsResponseDataGraphQL,
  IBaseAsset,
  IInlineHAQsResponseDataGraphQL,
  IInvitationResponseDataGraphQL,
  IStructuredDocumentResponseDataGraphQL,
} from "models/assets.models";
import { IQuestionsPaginatedResponse } from "models/HAQ.models";
import { QueryAPIKey } from "utils/constants/api.constants";
import queries from "../../queries";

export const assetsQueryConfig = {
  getQuestionsPaginated: {
    query: queries.assets.getQuestionsPaginated,
    queryKey: [QueryAPIKey.GetQuestionsPaginated],
    errorMessageKey: "getQuestionsFailure",
    queryOptions: {
      select: (data: IQuestionsPaginatedResponse) => data.questionsPage,
    },
  },

  getAssets: {
    query: queries.assets.getAssets,
    queryKey: [QueryAPIKey.GetAssets],
    errorMessageKey: "getAssetsFailure",
    queryOptions: {
      select: <T extends IBaseAsset>(data: IAssetsResponseDataGraphQL<T>) =>
        data.assets ?? [],
    },
  },

  getAssetsContent: {
    query: queries.assets.getAssetsContent,
    queryKey: [QueryAPIKey.GetAssets],
    errorMessageKey: "getAssetsFailure",
    queryOptions: {
      select: (data: IAssetsContentResponseDataGraphQL) => data.assets ?? [],
    },
  },

  getAssetsByRelationships: {
    query: queries.assets.getAssetsByRelationships,
    queryKey: [QueryAPIKey.GetAssetsByRelationships],
    errorMessageKey: "getAssetsByRelationshipsFailure",
    queryOptions: {
      select: <T extends IBaseAsset>(
        data: IAssetsByRelationshipsResponseDataGraphQL<T>,
      ) => data.assetsByRelationships ?? [],
    },
  },

  getInlineHAQs: {
    query: queries.assets.getInlineHAQs,
    queryKey: [QueryAPIKey.GetInlineHAQs],
    errorMessageKey: "getInlineHAQsFailure",
    queryOptions: {
      select: (data: IInlineHAQsResponseDataGraphQL) => data.inlineHAQs ?? [],
    },
  },

  getStructuredDocument: {
    query: queries.assets.getStructuredDocument,
    queryKey: [QueryAPIKey.GetStructuredDocument],
    errorMessageKey: "getStructuredDocumentFailure",
    queryOptions: {
      select: (data: IStructuredDocumentResponseDataGraphQL) =>
        data.structuredDocument,
    },
  },

  getInvitation: {
    query: queries.assets.getInvitation,
    queryKey: [QueryAPIKey.GetInvitation],
    errorMessageKey: "getInvitationFailure",
    queryOptions: {
      select: (data: IInvitationResponseDataGraphQL) => data.invitation,
    },
  },
};
